export default __webpack_public_path__ + "media/images/elephant_ui_plane_sub-7bf7fed0c0adb45bf4b0d25e6f6de3e7.png";